module.exports = __webpack_public_path__ + "img/logoinfo.3e27ec79.png";